import { Button, Modal, Table } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import pushApi from '../../api/push.api'

const AppPushTemplatesModal = ({
  open,
  onCancel,
  onSelect,
  selectedTemplate,
}) => {
  const [selectedRowKey, setSelectedRowKey] = useState([])
  const [appPushTemplateList, setAppPushTemplateList] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  // 모달이 열릴 때마다 현재 값과 일치하는 템플릿 찾아서 선택
  useEffect(() => {
    if (open && selectedTemplate) {
      const matchingTemplate = appPushTemplateList.find(
        (template) =>
          template.pushTitle === selectedTemplate.title &&
          template.pushBody === selectedTemplate.description &&
          (template.pushUrl || '') === (selectedTemplate.url || ''),
      )

      if (matchingTemplate) {
        setSelectedRowKey([matchingTemplate.id])
      } else {
        setSelectedRowKey([])
      }
    }
  }, [open, selectedTemplate, appPushTemplateList])

  const rowSelection = {
    type: 'radio',
    selectedRowKeys: selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectedRows[0]) {
        setSelectedRowKey(selectedRowKeys)
      }
    },
  }

  const columns = [
    {
      title: '템플릿 ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      ellipsis: true,
    },
    {
      title: '템플릿 이름',
      dataIndex: 'title',
      key: 'title',
      width: 180,
      ellipsis: true,
    },
    {
      title: '푸시 제목',
      dataIndex: 'pushTitle',
      key: 'pushTitle',
      width: 180,
      ellipsis: true,
    },
    {
      title: '푸시 내용',
      dataIndex: 'pushBody',
      key: 'pushBody',
      width: 300,
      ellipsis: true,
    },
    {
      title: 'URL',
      dataIndex: 'pushUrl',
      key: 'pushUrl',
      width: 120,
      ellipsis: true,
      render: (value) => value || '-',
    },
    {
      title: '이미지',
      dataIndex: 'pushImageUrl',
      key: 'pushImageUrl',
      width: 120,
      align: 'center',
      render: (_, record) => {
        return record.pushImageUrl ? (
          <img
            src={record.pushImageUrl}
            alt="푸시 이미지"
            style={{
              width: '60px',
              height: '60px',
              objectFit: 'cover',
              borderRadius: '4px',
            }}
          />
        ) : (
          '-'
        )
      },
    },
    {
      title: '생성일',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 140,
      ellipsis: true,
      render: (value) =>
        value ? dayjs(value).format('YYYY.MM.DD HH:mm') : '-',
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
  ]

  const getAppPushTemplateList = async () => {
    try {
      const res = await pushApi.getAppPushTemplates()
      if (res.status === 200) {
        setAppPushTemplateList(res.data.content)
        setTotalPages(res.data.totalPages)
      }
    } catch (error) {
      console.error('getAppPushTemplateList error:', error)
    }
  }

  useEffect(() => {
    if (open) {
      getAppPushTemplateList()
    }
  }, [open])

  const handleSelect = () => {
    const selectedData = appPushTemplateList.find(
      (item) => item.id === selectedRowKey[0],
    )
    if (selectedData) {
      onSelect(selectedData)
      onCancel()
    }
  }

  const onRow = (record) => ({
    onClick: () => {
      setSelectedRowKey([record.id])
    },
    style: {
      cursor: 'pointer',
    },
  })

  return (
    <Modal
      title="템플릿 불러오기"
      open={open}
      onCancel={onCancel}
      width={1200}
      centered
      footer={[
        <Button key="cancel" onClick={onCancel}>
          취소
        </Button>,
        <Button
          key="select"
          type="primary"
          onClick={handleSelect}
          disabled={!selectedRowKey.length}
        >
          선택
        </Button>,
      ]}
    >
      <Table
        rowSelection={rowSelection}
        columns={columns}
        dataSource={appPushTemplateList}
        bordered
        size="middle"
        rowKey="id"
        scroll={{ y: 'calc(100vh - 400px)' }}
        pagination={false}
        onRow={onRow}
      />
    </Modal>
  )
}

export default AppPushTemplatesModal
